export enum EBodyClass {
  NORMAL = "page-normal",
}
